import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import { ProgressBar } from "react-bootstrap";

const AnimatedProgressBar = ({ duration, onComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (duration > 0) {
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsedTime = Date.now() - startTime;
        const newProgress = (elapsedTime / duration) * 100;
        setProgress(newProgress <= 100 ? newProgress : 100);

        if (newProgress >= 100) {
          clearInterval(interval);
          onComplete(true); // Pass data to the onComplete function
        }
      }, 10); // Update the interval time as needed for smoother animation

      return () => {
        clearInterval(interval);
      };
    }
  }, [duration, onComplete]);

  return (
    <div className="progress-container w-80 mx-auto mb-4">
      <ProgressBar variant="success" now={progress} />
    </div>
  );
};

AnimatedProgressBar.propTypes = {
  duration: PropTypes.number.isRequired,
  onComplete: PropTypes.func
};

export default AnimatedProgressBar;
